export class DetailWs {
  id: number;

  constructor(id: number) {
    this.id = id;
  }
}
